up.compiler('[data-bs-toggle="tooltip"]', (element) => {
    new bootstrap.Tooltip(element);
})

// remove tooltips by up-target links with tooltips
up.compiler('[up-target]', (element) => {

    element.addEventListener('click', function(){
        let tooltip = this.getAttribute('aria-describedby');
        if (tooltip) {
            document.getElementById(tooltip).remove();
        }
    });
})
